import { PencilSquareIcon, TrashIcon } from '@heroicons/react/20/solid'
import { Link }                        from 'react-router-dom'

export default function SettingsShopProductsListTableItem( props: any ): JSX.Element {
  const { shopCategory, shopProduct, currentUser, handleDelete } = props

  return (
    <>
      { shopProduct && shopCategory &&
        <div className="bg-white rounded-2xl p-2 2xl:p-4 w-full flex flex-col md:flex-row md:justify-between gap-2">
          <div className="flex justify-center flex-col w-full">
            <Link to={ `/shop/${ shopCategory.slug }/${ shopProduct.id }` } className="text-blue-header font-bold text-xl">
              <span>{ shopProduct.name }</span>
            </Link>
          </div>

          <div className="flex justify-center flex-col w-full">
            <span className="font-normal">{ shopCategory.name }</span>
          </div>

          <div className="flex justify-end md:justify-center items-center">
            <Link to={ `/settings/shop/products/edit/${ shopProduct.id }` }>
              <button className="flex items-center text-sm text-blue-input font-medium px-3 py-1 bg-yellow-300 rounded-full">
                <PencilSquareIcon className="w-4 h-4" />
                <span className="pl-1 text-left">Edit</span>
              </button>
            </Link>

            { currentUser.email === 'dawid@denfield.co.uk' &&
              <button
                className="flex items-center text-sm text-blue-input font-medium px-3 py-1 ml-2 bg-red-500 rounded-full"
                onClick={ handleDelete }
              >
                <TrashIcon className="w-4 h-4" />
                <span className="pl-1 text-left">Delete</span>
              </button>
            }
          </div>
        </div>
      }
    </>
  )
}
